var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.533,
    height: 20.533,
    viewBox: "0 0 20.533 20.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.261-.008a.856.856,0,0,0-.843.869V3.428a.856.856,0,0,0,1.712,0V.861a.856.856,0,0,0-.869-.869ZM3.611,2.751a.856.856,0,0,0-.6,1.469L4.83,6.034a.856.856,0,1,0,1.211-1.21L4.225,3.01a.856.856,0,0,0-.614-.259Zm13.3,0a.856.856,0,0,0-.589.259L14.508,4.825a.856.856,0,1,0,1.211,1.21L17.535,4.22a.856.856,0,0,0-.622-1.469ZM10.274,5.139a5.133,5.133,0,1,0,5.137,5.133A5.148,5.148,0,0,0,10.274,5.139Zm0,1.711A3.422,3.422,0,1,1,6.85,10.272,3.41,3.41,0,0,1,10.274,6.85ZM.864,9.41a.856.856,0,1,0,0,1.711H3.432a.856.856,0,1,0,0-1.711Zm16.253,0a.856.856,0,1,0,0,1.711h2.568a.856.856,0,1,0,0-1.711Zm-11.7,4.827a.856.856,0,0,0-.589.259L3.014,16.311a.856.856,0,1,0,1.211,1.21l1.816-1.815a.856.856,0,0,0-.622-1.469Zm9.685,0a.856.856,0,0,0-.6,1.469l1.816,1.815a.856.856,0,1,0,1.211-1.21L15.719,14.5A.856.856,0,0,0,15.1,14.237Zm-4.842,2a.856.856,0,0,0-.843.867V19.67a.856.856,0,0,0,1.712,0V17.1a.856.856,0,0,0-.869-.867Z",
    transform: "translate(-0.008 0.008)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.1e3201bf7df515b55240390e03975685.svg";
export { ForwardRef as ReactComponent };